import {action, query, redirect} from "@solidjs/router";
import sdk from "~/sdk/sdk";
import {ForgotPasswordRequest, ResetPasswordRequest, SignInRequest} from "@gs-yoga/sdk/types/auth";
import {ApiError} from "~/sdk/error";
import {getMember} from "~/sdk/member";


export const getUser = query(async () => {
    try {
        return await sdk().auth.me().json()
    } catch (error: any) {
        const status = error.response?.status
        if (status === 401) {
            return null
        }
        throw new ApiError("Failed to get user", error)
    }
}, "user")

export const signOut = action(async () => {
    try {
        await sdk().auth.signOut()
        return redirect("/", {revalidate: [getUser.key, getMember.key]})
    } catch (e) {
        throw new ApiError("Failed to sign out", e)
    }
})

export const signIn = action(async (req: SignInRequest) => {
    try {
        await sdk().auth.signIn(req)
    } catch (error: any) {
        const status = error.response?.status
        if (status === 500) {
            throw new ApiError("Failed to sign in", error)
        }
        throw new ApiError("Your email or password is incorrect", error)
    }
})

export const forgotPassword = action(async (req: ForgotPasswordRequest) => {
    try {
        await sdk().auth.forgotPassword(req)
    } catch (error: any) {
        const status = error.response?.status
        if (status === 404) {
            throw new ApiError("No member exists with this email", error)
        }
        throw new ApiError("Failed to send reset password email", error)
    }
})

export const resetPassword = action(async (req: ResetPasswordRequest) => {
    try {
        await sdk().auth.resetPassword(req)
    } catch (e) {
        throw new ApiError("Failed to reset password", e)
    }
})